module.exports = __webpack_public_path__ + "img/herbin.f44eaf06.jpg";